import { render, staticRenderFns } from "./recover-password.vue?vue&type=template&id=56083fbf"
import script from "./recover-password.vue?vue&type=script&lang=js"
export * from "./recover-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56083fbf')) {
      api.createRecord('56083fbf', component.options)
    } else {
      api.reload('56083fbf', component.options)
    }
    module.hot.accept("./recover-password.vue?vue&type=template&id=56083fbf", function () {
      api.rerender('56083fbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/recover-password.vue"
export default component.exports